<template>
  <div v-if='!item.hidden'>
    <!-- //循环数据；数据menuList通过props传递 -->
    <!-- {{item.children}} -->
    <template>
      <!-- <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)"> -->
      <el-submenu tag='sub-menu' v-if='item.sub && item.sub.length > 0' :index='item.code' popper-append-to-body>
        <template slot='title'>
          <item class='iconfont' :icon='item.icon && item.icon' :title='generateTitle(item)' />
        </template>
        <!--  //当有子级数据再次使用这个模板，:menuList通过props传递 -->
        <!-- <Menus v-show="!item.hidden" :menuList="item.children"></Menus> -->
        <Menus v-for='child in item.sub' :key='child.url' :is-nest='true' :item='child' class='nest-menu'></Menus>
      </el-submenu>
      <el-menu-item :class='`driver-item-${item.code}`' v-else :index='item.url' v-show='!item.hidden'
                    popper-append-to-body>
        <item :icon='item.icon && item.icon' :title='generateTitle(item)' />
      </el-menu-item>
    </template>
  </div>
</template>

<style scoped lang='scss'>
.el-menu--collapse span,
.el-menu--collapse i.el-submenu__icon-arrow {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}

::v-deep .el-submenu__icon-arrow.el-icon-arrow-down {
  // 需求要求图标对齐
  transform-origin: 8px 8px;
}
</style>
<script>
import Item from './Item'
import AppLink from './Link'
import { generateTitle } from '@/utils/i18n'
import bus from '@/utils/bus.js'

export default {
  // props: ['menuList'],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Item,
    AppLink
  },
  name: 'Menus', // 模板名称
  data () {
    return {
      arrname: null,
      col: false
    }
  },
  beforeMount () {
  },
  methods: {
    generateTitle
  },
  created () {
  },
  mounted () {
    if (bus._collapse_ != 'undefined' && bus._collapse_ === true) {
      var cls = this.$el.className
      if (cls == 'nest-menu') {
        var tag = this.$parent.$el.getAttribute('tag')
        if (tag == 'sub-menu') {
          this.$parent.$el.children[0].style.paddingLeft = '7px'
        }
      }
    }
  }
}
</script>
